<template>
  <div>
    <b-table
      :fields="fields"
      :items="items"
      :busy="storeBusy"
      id="employee-page-table"
      ref="employee-page-table"
      table-class="table-head-custom table-vertical-center"
      responsive
      show-empty
      hover
      @row-clicked="showEmployeeDetails"
    >
      <!-- begin: t-head -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>
      <!-- end: t-head -->

      <!-- begin: t-row -->
      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">{{ data.index + 1 }}</span>
      </template>

      <template v-slot:cell(full_name)="data">
        <CommonEmployeeSummary
          :item="convertToSummary(data)"
        ></CommonEmployeeSummary>
      </template>

      <template v-slot:cell(group)="data">
        {{ data.item.group }}
      </template>

      <!--  begin:: actions    -->
      <template v-slot:cell(actions)="data">
        <div class="d-flex flex-row justify-content-left">
          <!-- begin::: edit-employee button -->
          <button
            class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
            v-on:click="showEmployeeDetails(data.item)"
            v-b-tooltip.hover
            :title="$t('STAFF.TOOLTIP.EDIT')"
          >
            <span class="svg-icon svg-icon-primary menu-icon">
              <inline-svg src="/media/svg/icons/Communication/Write.svg" />
            </span>
          </button>
          <!-- end::: edit-employee button -->

          <!-- begin::: edit-employee button -->

          <!-- end::: edit-employee button -->

          <button
            class="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
            v-on:click="deleteStaff(data)"
            v-b-tooltip.hover
            :title="$t('TEACHER.TOOLTIP.DELETE', { teacher: data.item.name })"
          >
            <span class="svg-icon svg-icon-gray menu-icon">
              <inline-svg src="/media/svg/icons/General/Trash.svg" />
            </span>
          </button>
          <!-- end::: delete-employee button -->
        </div>
      </template>
      <!--  end:: actions    -->

      <!-- end: t-row -->

      <template #table-busy>
        <AppLoader #table-busy></AppLoader>
      </template>

      <template #empty>
        <AppEmptyList
          text-top="No staffs registered"
          text-bottom="To register staff, click at the CREATE button"
        ></AppEmptyList>
      </template>
    </b-table>

    <div class="d-flex justify-content-end" v-if="items.length">
      <b-pagination
        pills
        size="lg"
        align="right"
        class="pt-5"
        @change="changePage"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        aria-controls="employee-page-table"
      ></b-pagination>
    </div>

    <StaffPageDetailsModal
      :title="selectedEmployee.name"
      :selected-employee="selectedEmployee"
      @detailsUpdated="refresh"
    ></StaffPageDetailsModal>

    <CompanyAdminAssignmentModal
      :employee="selectedEmployee"
    ></CompanyAdminAssignmentModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import CompanyAdminAssignmentModal from "@/modules/company/components/employees/admin/CompanyAdminAssignmentModal";
import CommonEmployeeSummary from "@/modules/core/components/company/CommonEmployeeSummary";
import AppEmptyList from "@/modules/core/components/empty/AppEmptyList";
import StaffPageDetailsModal from "@/modules/school/components/staff/list/StaffPageDetailsModal";

export default {
  name: "StaffTable",
  props: ["reload"],
  components: {
    StaffPageDetailsModal,
    AppEmptyList,
    CommonEmployeeSummary,
    CompanyAdminAssignmentModal,
    AppLoader,
  },

  data() {
    return {
      perPage: 10,
      currentPage: 1,
      fields: [
        { key: "index", label: "#" },
        { key: "full_name", label: this.$t("STAFF.HEADER"), sortable: true },
        { key: "group", label: "Group", sortable: true },
        { key: "actions", label: this.$t("EDUTABLE.ACTIONS") },
      ],
      selectedEmployee: {},
      isBusy: false,
    };
  },

  mounted() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.isBusy = true;
      return this.$store
        .dispatch("fetchStaffList")
        .then((response) => {
          console.log("Received", response);
          return response.data.data;
        })
        .finally(() => (this.isBusy = false));
    },

    /**
     * Show details modal.
     *
     * @param item
     */
    showEmployeeDetails(item) {
      console.log("Selected employee row", item);

      this.selectedEmployee = {
        name: `${item.first_name} ${item.last_name}`,
        firstName: item.first_name,
        lastName: item.last_name,
        code: item.code,
        email: item.email,
        id: item.id,
        image_url: item.image_url,
      };

      console.log("Selected employee item", this.selectedEmployee);

      this.$bvModal.show("common-employee-details-modal");
      this.$store.dispatch("assignEmployeeId", item.id).then(() => {
        console.log("Done setting employee Id");
      });
    },

    deleteStaff(row) {
      console.log(row.item);

      this.$bvModal
        .msgBoxConfirm(`This will delete ${row.item.first_name}`, {
          title: this.$t("ALERT.SURE"),
          centered: true,
          noCloseOnBackdrop: true,
          cancelVariant: "light",
        })
        .then((value) => {
          console.log("Hmmm", value);
          if (value) {
            return new Promise((resolve, reject) => {
              this.$store
                .dispatch("deleteStaff", row.item.id)
                .then(() => {
                  this.$bvModal.msgBoxOk("Success!!", {
                    centered: true,
                  });
                  this.refresh();
                  resolve(value);
                })
                .catch(() => {
                  console.error("Some issues bro");
                  this.$bvModal.msgBoxOk("Failed!!", {
                    centered: true,
                    okVariant: "danger",
                  });
                  reject(value);
                });
            });
          }
        })
        .catch((err) => {
          console.error("Some issues bro", err);
        });
    },

    refresh() {
      console.log("Reload Table!");
      this.fetch();
    },

    convertToSummary(row) {
      console.log(row);
      const item = row.item;
      return {
        name: item.first_name + " " + item.last_name,
        code: item.code,
        email: item.email,
        image_url: item.image_url,
      };
    },

    /**
     * Change the page to the given value
     *
     * @param page
     */
    changePage(page) {
      console.log("Change page to ", page);
      this.$store.commit("setStaffListPage", page);
      this.fetch();
    },

    /**
     * Assign staff as admin
     *
     * @param data
     */
    assignAsAdmin(data) {
      console.log("Assigning ", data.item.id);
      this.selectedEmployee = {
        name: data.item.first_name,
        id: data.item.id,
      };
      this.$bvModal.show("employee-admin-assignment-modal");
    },
  },

  watch: {
    reload() {
      this.fetch();
    },
  },

  computed: {
    ...mapGetters(["getSuperAdminPermission"]),
    ...mapGetters({
      items: "getStaffList",
      pagination: "getStaffListPagination",
      currentPage: "getStaffListPage",
      storeBusy: "getStaffListBusy",
    }),
  },
};
</script>

<style scoped></style>
}
